export default {
  "ORDER_WAIT_SHIP": "शिप के लिए प्रतीक्षा करें",
  "Men fashion": "पुरुषों का फैशन",
  "MyAccount_MyProfile_label_First": "नाम",
  "MyAccount_MyShippingDetails_Phone": "फोन नंबर",
  "Page_not_found_message1": "माफ़ कीजिये पृष्ठ नहीं मिल सका",
  "Help": "मदद",
  "Sign in": "साइन इन करें",
  "Register": "रजिस्टर करें",
  "Category_sorting_Item": "चयन सॉर्टिंग विधि",
  "cart_clear": "कार्ट साफ़ करें",
  "Payment & Delivery": "भुगतान और वितरण",
  "Send my feedback": "मेरी प्रतिक्रिया भेजें",
  "MyAccount_MyProfile_Save": "बदलाव सहेजें",
  "Continue_billing": "बिलिंग जारी रखें",
  "Categories": "श्रेणियाँ",
  "Read and understand": "मैंने पढ़ा और समझ लिया है",
  "Feel free to edit": "अपनी विस्तृत जानकारी कभी भी संपादित करें ताकि आपका खाता सदैव अद्यतन रहे",
  "Select payment method": "भुगतान विधि का चयन करें",
  "Login_input_email": "आपका ईमेल",
  "Login_input_first": "नाम",
  "Account": "खाता",
  "Create_Time_Asc": "समय क्रमित करें उद्घाटन करें",
  "concactus_label": "सुझाव या समस्या",
  "Order_Grade": "आदेश ग्रेड",
  "wishlist_empty_desc": "लगता है कि आपने कोई भी आइटम कार्ट में जोड़ा नहीं है। खरीददारी शुरू करें!",
  "cartpreviewShipping_messageinfo": "आपकी शिपमेंट की पुष्टि और आगमन तिथि मिलेगी",
  "unsubscribe": "आप कभी भी सदस्यता रद्द कर सकते हैं",
  "prompt": "अलर्ट",
  "MyAccount_MyProfile_yinsi_message": "हम Brand name में गोपनीयता मानदंडों का विशेष महत्व देते हैं और उपयोगकर्ताओं के व्यक्तिगत डेटा को संरक्षित करने के लिए समर्पित हैं। अपने व्यक्तिगत डेटा से कैसे मुद्दे संबंधित जानकारी पढ़ें, कृपया देखें",
  "About us": "हमारे बारे में",
  "or": "या",
  "MyAccount_Order_History_All": "सभी ऑर्डर",
  "What_We_Improve": "हम कैसे सुधार सकते हैं?",
  "MyAccount_ShippingDetails_title": "शिपिंग विवरण",
  "MyAccount_Order_History_Tabs2": "भुगतान के लिए प्रतीक्षा करें",
  "Go_back_shopping": "खरीदारी पर वापस जाएं",
  "Product": "उत्पाद",
  "Order summary": "आदेश सारांश",
  "payment_order_total": "आदेश कुल राशि",
  "Departments": "विभाग",
  "Download": "डाउनलोड",
  "Your_Purchase_Order": "आपके आर्डर",
  "Your_Account": "आपका खाता",
  "order_after_sales_list_null": "आपके पास वर्तमान में कोई भी आदेश के बाद की सेवा नहीं हैं",
  "All_After_sales_orders": "सभी आदेश के बाद की सेवा",
  "Filters": "फ़िल्टर",
  "search_results_not": "हम दिए गए शब्द से संबंधित परिणाम नहीं मिले",
  "ORDER_WAIT_RECEIPT": "इंतजार कर रहा है प्राप्त होने के लिए",
  "ORDER_CLOSED": "बंद है",
  "Order_View_details": "विस्तृत जानकारी देखें",
  "Subscribe_to_message": "आगामी बिक्री और इवेंट जानें। उपहार और विशेष ऑफर पाएं!",
  "TaxFee": "कर प्रबंधन शुल्क",
  "Apply": "लागू करें",
  "Total_price": "कुल मूल्य",
  "Description": "विवरण",
  "Payment method": "भुगतान विधि",
  "Back": "वापस जाएं",
  "Empty": "लगता है कि आपने कोई आइटम कार्ट में जोड़ा नहीं है। भर देने के लिए शॉपिंग शुरू करें।",
  "After_sales": "बाद में बिक्री",
  "Instruction3": "हाँ हम जानते हैं",
  "MyAccount_MyShippingDetails_Last": "अंतिम नाम",
  "MyAccount_MyShippingDetails_City": "शहर",
  "payment_order_discount": "ऑर्डर डिस्काउंट",
  "MyAccount_Order": "ऑर्डर विवरण",
  "ID_Name_Error": "कृपया अपना आईडी नाम दर्ज करें",
  "Kidswear": "बच्चों के कपड़े",
  "Share your look": "अपनी दिखावट साझा करें",
  "Pay_Order": "आदेश भुगतान करें",
  "Reset_Password": "पासवर्ड रीसेट करें",
  "MyAccount_MyProfile_label2_pass1": "वर्तमान पासवर्ड",
  "Create_Time_Desc": "तैयार करते समय क्रमित करें",
  "Items": "आइटमें",
  "Login_Register": "अभी रजिस्टर करें",
  "Back to homepage": "होमपेज पर वापस जाएं",
  "switch_CNY": "कीमतें रुपये में",
  "Successful placed order": "आपने सफलतापूर्वक ऑर्डर दिया है। आप हमारी डिलीवरी स्थिति विशेषता का उपयोग करके आदेश स्थिति की जाँच कर सकते हैं। ऑर्डर की पुष्टि करने वाला एक ईमेल आपको ऑर्डर विवरण और ट्रैकिंग लिंक के साथ मिलेगा।",
  "MyAccount_MyProfile_yinsi_link": "गोपनीयता नीति",
  "Order_Date": "ऑर्डर तिथि",
  "Allow order notifications": "ऑर्डर नोटिफिकेशन की अनुमति दें",
  "MyAccount_MyProfile_Tab1": "व्यक्तिगत विवरण",
  "MyAccount_ShippingDetails_changeTitle": "पते को बदलें",
  "ID_Number": "आईडी नंबर",
  "Order_after_sales_message": "विवरण और आदेश के बाद सेवा",
  "MyAccount_MyProfile_title2": "यदि आप अपने खाते एक्सेस करने के लिए पासवर्ड बदलना चाहते हैं, तो कृपया निम्नलिखित जानकारी दर्ज करें:",
  "Customer service": "ग्राहक सेवा",
  "MyAccount_MyProfile_Update": "पासवर्ड अपडेट करें",
  "choose_language": "भाषा चुनें",
  "ORDER_REFUNDING": "धन वापसी",
  "MyAccount_MyProfile_title1": "अपनी विस्तृत जानकारी कभी भी संपादित करें ताकि आपका खाता सदैव अद्यतन रहे",
  "ORDER_WAIT_RATE": "असमाप्त",
  "after_sales_refund_order": "ऑर्डर रिफंड",
  "Who we are": "हम कौन हैं",
  "Women fashion": "महिलाओं का फैशन",
  "Order_After_sales": "आदेश वापसी",
  "concattus_button": "जमा करें",
  "Shipping_valid_required": "यह एक आवश्यक फ़ील्ड है",
  "Price": "मूल्य",
  "ID_Type_Error": "अपने पहचान पत्र के प्रकार का चयन करें",
  "Order_Status": "आदेश की स्थिति",
  "Payment methods": "भुगतान के तरीके",
  "MyAccount_MyProfile_Tab2": "पासवर्ड बदलें",
  "Show on page": "पृष्ठ पर दिखाएँ",
  "Edit": "संपादित करें",
  "Change": "बदलें",
  "MyAccount_ShippingDetails_Update": "पता अपडेट करें",
  "View": "देखें",
  "Privacy": "गोपनीयता",
  "Enter_promo_code": "प्रोमो कोड दर्ज करें",
  "Discount": "डिस्काउंट",
  "Delete": "हटाएँ",
  "Wishlist": "इच्छा-सूची",
  "MyAccount_Order_History_Tabs3": "वापसी करें",
  "Go_To_Order_review": "समीक्षा करें",
  "Update personal data": "अपना व्यक्तिगत डेटा अपडेट करें",
  "payment_agree_2": "शर्तें और नियम",
  "or fill the details below": "या नीचे विवरण भरें",
  "Contact details updated": "आपका पता और संपर्क जानकारी अपडेट करें।",
  "Login_Create": "खाता बनाएँ",
  "Payment": "भुगतान",
  "Billing": "बिलिंग",
  "payment_insurance_tax": "बीमा टैक्स",
  "Size guide": "साइज़ गाइड",
  "Login_forgotten_password": "पासवर्ड भूल गए?",
  "Login_no_account": "कोई खाता नहीं है?",
  "Privacy_Policy": "गोपनीयता नीति",
  "BootomCookieTitle": "कुकी अनुमति",
  "Use your personal data": "ब्रांड नेम पर हम गोपनीयता मामलों को बहुत महत्व देते हैं और हमारे उपयोगकर्ताओं के व्यक्तिगत डेटा की सुरक्षा में समर्थ हैं। अपने व्यक्तिगत डेटा की देखभाल और इसका उपयोग करने के बारे में अधिक जानकारी के लिए देखें",
  "Review my order": "मेरा आदेश समीक्षा करें",
  "BootomCookieLink": "अधिक जानकारी",
  "hide": "छिपाएँ",
  "MyAccount_ShippingDetails_message_title": "(ऑफ़िस, घर का पता आदि) सभी आपके चाहने वाले शिपिंग पते को नियंत्रित करें ताकि आपको हर आदेश में शिपिंग पता हाथ से नहीं दालने की आवश्यकता हो।",
  "Purchase terms": "खरीदारी की शर्तें",
  "Billing_address": "बिलिंग पता",
  "Manage shipping addresses": "(ऑफ़िस, घर का पता आदि) सभी आपके चाहने वाले शिपिंग पते को नियंत्रित करें। इससे आपको हर आदेश में शिपिंग पता हाथ से नहीं डालने की जरूरत होती है।",
  "login_logbtn": "लॉग इन करें",
  "choose_currency": "मुद्रा चुनें",
  "ORDER_REFUNDED": "वापसी हुई",
  "After_sales_form": "बिक्री के बाद के और पत्र भरें",
  "add_To_Wishlist": "इच्छा-सूची में जोड़ें",
  "search_results_inputnull2": "अभी आरंभ करें, हम आपकी मदद करेंगे।",
  "Total": "संपूर्ण",
  "Subscribe_to_newsletter": "समाचार पत्रिका के लिए सदस्यता लें",
  "Shipping_valid_Phone": "एक मान्य फोन नंबर दर्ज करें",
  "concactus_label3": "शीर्षक",
  "Manage billing addresses": "सभी आपके चाहने वाले बिलिंग पते को नियंत्रित करें। इससे आपको हर आदेश में बिलिंग पता हाथ से नहीं डालने की जरूरत होती है।",
  "Search_results_title": "खोज परिणाम",
  "payment_order_payment": "ऑर्डर भुगतान",
  "after_sales_Id": "विक्रय बाद ID",
  "cart_title": "मेरी शॉपिंग कार्ट",
  "Order_Detail": "ऑर्डर की विस्तृत जानकारी",
  "concactus_label2": "स्टोर लिंक",
  "Shipping_valid_length_min": "कम से कम {min} वर्ण होने की आवश्यकता है",
  "Product suggestions": "उत्पाद सुझाव",
  "Return_home": "घर वापिस जाओ",
  "Quality in the details": "विवरण में गुणवत्ता",
  "Continue_to_payment": "भुगतान जारी रखें",
  "Feedback": "आपकी प्रतिक्रिया हमारे लिए बहुत महत्वपूर्ण है। कृपया हमें बताएं कि हम क्या सुधार कर सकते हैं।",
  "Go back to shop": "वापस शॉपिंग पर जाएं",
  "Back_to_home": "वापस घर पर जाएं",
  "Review_Content": "समीक्षा सामग्री",
  "add_To_Cart": "कार्ट में डालें",
  "Read_reviews": "समीक्षा पढ़ें",
  "Instruction1": "संरक्षण विधि",
  "Email_address": "ईमेल पता",
  "Category_Item_List": "सूची दृश्य को बदलें",
  "Same as shipping address": "शिपिंग पते के तरह",
  "Category_Item_Grid": "ग्रिड दृश्य को बदलें",
  "ID_Number_Error": "अपना आईडी नंबर दर्ज करें",
  "concactus_label4": "संपर्क ईमेल",
  "Additional_info": "अतिरिक्त जानकारी",
  "add_shipping": "नया शिपिंग पता जोड़ें",
  "Product_description": "Karissa V-Neck टीं आधारभूत ढंग से तैयार की गई है, सभी आकारों के लिए उपयुक्त। यह कुर्वों को लगातार ढंकता है और सामान्य \"मुद्दे\" क्षेत्रों को ढकने में मदद करता है, जिससे आप जिम जा सकते हैं। यहाँ अद्भुत महिलाओं कोकटेल ड्रेस और पार्टी ड्रेस भी हैं।",
  "Login_create_account": "मैं खाता बनाना चाहता हूँ",
  "after_sales_Reason": "आदेश वापसी का कारण",
  "MyAccount_MyProfile_label_Last": "अंतिम नाम",
  "MyAccount_MyProfile_label2_pass2": "नया पासवर्ड",
  "Save": "बचाएँ",
  "CartSliderTextBtn": "बाद में खरीदने के लिए सहेजें",
  "Color": "रंग",
  "Shipping_Tax": "शिपिंग टैक्स",
  "Subscribe_to_success": "आपकी सदस्यता सफलतापूर्वक हुई है",
  "Enjoy your free account": "अपने नि: शुल्क खाते का आनंद लें!",
  "cart_empty_desc": "लगता है कि आपने अभी तक खरीदारी की कोई वस्तु अपनी शॉपिंग बैग में नहीं जोड़ी है। इसे भरना शुरू करें।",
  "MyAccount_ShippingDetails_message_title2": "आपका पता और संपर्क जानकारी अपडेट करें।",
  "An_error_occured": "एक त्रुटि हुई",
  "Country": "देश",
  "MyAccount_MyShippingDetails_First": "नाम",
  "payment_insurance_fee": "बीमा शुल्क",
  "Home": "होम",
  "Contact_us": "हमसे संपर्क करें",
  "Cookies Policy": "कुकी नीति",
  "Clear all": "सभी साफ़ करें",
  "Basket": "खरीदारी की टोकरी",
  "MyAccount_MyProfile_reqeatPassErrMsg": "नई पासवर्ड मेल नहीं खाता",
  "Your current email address is": "आपका वर्तमान ईमेल पता है",
  "You currently have no orders": "आपके पास वर्तमान में कोई ऑर्डर नहीं है",
  "Login_input_password": "पासवर्ड",
  "Promo_code": "प्रचार कोड",
  "order_count": "आदेश संख्या",
  "email_geshi_error": "कृपया वैध ईमेल पता दर्ज करें",
  "your_email": "आपका ईमेल",
  "email": "ईमेल",
  "you_have_subscribed": "आप इसे सब्सक्राइब कर चुके हैं",
  "cancel_Subscribe": "सब्सक्राइब रद्द करें",
  "save_and_pay": "बचाएँ और भुगतान करें",
  "hasInsurance": "क्या आपने बीमा खरीदा है",
  "pleasePayType": "कृपया भुगतान का तरीका चुनें",
  "zhuanfa_toBePay": "दोस्त को भुगतान करने के लिए भेजें",
  "linkCopied": "जालस्थल प्रतिलिपि किया गया है, जल्दी से दोस्तों के साथ साझा करने के लिए पेस्ट करें",
  "Personal details": "व्यक्तिगत विवरण",
  "Password": "पासवर्ड",
  "wishlist_empty_title": "आपकी खरीदारी बैग खाली है",
  "Repeat_Password": "दोहराना पासवर्ड",
  "cart_price": "शुल्क",
  "Sort_by": "क्रमबद्ध करें द्वारा",
  "Customer Reviews": "ग्राहक समीक्षा",
  "Continue to shipping": "शिपिंग जारी रखें",
  "payment_make_order": "आदेश दें",
  "save_order_review": "समीक्षा सहेजें",
  "Save_Password": "पासवर्ड सहेजें",
  "cart_empty_title": "आपकी खरीदारी कार्ट खाली है",
  "TopBar_help": "मदद और आम सवालों के उत्तर",
  "colseCookie": "मैं समझता हूँ",
  "Password_Changed": "पासवर्ड सफलतापूर्वक बदल दिया गया है। आप अब वापस मुखपृष्ठ पर जा सकते हैं और लॉगिन कर सकते हैं।",
  "Forgot Password Modal Email": "आपकी लॉगिन करने के लिए ईमेल:",
  "MyAccount_Personal": "व्यक्तिगत विवरण",
  "cartPreviewShipping": "शिपिंग",
  "ORDER_AFTER_SALE": "विक्रय के बाद",
  "Page_not_found": "पृष्ठ नहीं मिला",
  "Find out more": "और अधिक जानें",
  "Log into your account": "अपने खाते में लॉग इन करें",
  "Details_and_status_orders": "ऑनलाइन स्टोर में आर्डर की विस्तृत जानकारी और स्थिति की जांच करें। आप आर्डर रद्द या वापस करवा सकते हैं।",
  "Order_to_be_paid_message": "भुगतान करने के लिए आदेश",
  "Guarantee": "गारंटी",
  "Sections that interest you": "आपको प्रेरित करने वाले अनुभाग",
  "payment_post_tax": "मुद्रण भार",
  "ORDER_PAID": "भुगतान जोखिम हो गया है",
  "concactus_label5": "नाम",
  "Item": "वस्तु",
  "Go_back": "वापस जाएं",
  "more": "अधिक",
  "MyAccount": "मेरा खाता",
  "payment_agree_1": "मैं सहमत हूं",
  "total_items": "कुल मद",
  "shopping_go": "शिपिंग पते प्रबंधित करें",
  "ID_Type": "आईडी प्रकार",
  "after_sales_status": "विक्रय के बाद की स्थिति",
  "After_sales_apply": "विक्रय के बाद आवेदन करें",
  "Login": "लॉग इन करें",
  "Quantity": "मात्रा",
  "payment_post_fee": "शिपिंग शुल्क",
  "MyAccount_Log_out": "लॉग आउट",
  "Subtotal": "उप कुल",
  "forgotPasswordConfirmation": "धन्यवाद! यदि आपने {0} ईमेल का उपयोग करके खाता रजिस्टर किया है तो आपके इनबॉक्स में पासवर्ड रीसेट लिंक समेत संदेश मिलेगा।",
  "MyAccount_Order_History_Tabs1": "मेरे आदेश",
  "concactus_img": "तस्वीर अपलोड करें",
  "Done": "किया हुआ",
  "Info after order": "आप अपने खाते में पहले से निर्धारित ईमेल और पासवर्ड का उपयोग करके लॉग इन कर सकते हैं। अपने खाते में, आप व्यक्तिगत जानकारी संपादित कर सकते हैं, व्यापार इतिहास देख सकते हैं, सदस्यता समाचार पत्र संपादित कर सकते हैं इत्यादि।",
  "MyAccoubnt_Set_newsletter": "अपनी समाचार पत्रिका सेट करें, हम हर हफ्ते आपको आपके द्वारा चयनित उत्पादों और रूझानों की नई सूचनाएं भेजते हैं।",
  "Shipping_method": "शिपिंग मेथड",
  "after_sales_refund": "वापसी राशि",
  "After_sales_save": "बिक्री बाद की जानकारी सहेजें",
  "go_order_history": "ऑर्डर निवेदन का इतिहास देखें",
  "contactus_message_placeholder": "अपनी टिप्पणी या समस्याओं को भरें",
  "Login_Forgot_Password": "अगर आप पासवर्ड याद नहीं कर पा रहे हैं, तो आप पासवर्ड रीसेट कर सकते हैं।",
  "show_more": "अधिक देखें",
  "MyAccount_MyProfile_label_email": "आपका ईमेल",
  "MyAccount_MyProfile_label2_pass3": "पासवर्ड दोहराएं",
  "Products": "उत्पाद",
  "Review": "समीक्षा",
  "MyAccount_MyProfile_title3": "आपका वर्तमान ईमेल पता है",
  "Category_found_Products": "खोजे गए उत्पादों",
  "Match": "मेल खाने वाला",
  "Read_all_reviews": "सभी समीक्षाएं पढ़ें",
  "Commercial information": "मैं ब्रांड नाम से अपनी व्यक्तिगत व्यापार सूचनाओं को ईमेल द्वारा प्राप्त करने को सहमत हूँ",
  "Change password your account": "यदि आप अपने खाते के लिए पासवर्ड बदलना चाहते हैं, तो निम्नलिखित जानकारी भरें",
  "ID_Name": "आधार कार्ड नाम",
  "All": "सब",
  "Instruction2": "हार महसूस करते हो?",
  "MyAccount_ShippingDetails_Add": "नई पता जोड़ें",
  "MyAccount_MyShippingDetails_Zip": "पिन कोड",
  "go_pay_order": "भुगतान करने जाएं",
  "Thank_You_Inbox": "यदि संदेश आपके इनबॉक्स में नहीं पहुंचता है, तो दूसरा ईमेल पता उपयोग करने का प्रयास करें जिसे आपने शायद पंजीकरण के लिए उपयोग किया हो।",
  "Subscribe": "सदस्यता लें",
  "confirm_subscription": "मैं सदस्यता के लिए पुष्टि करता हूं",
  "Login_input_Remember": "मुझे याद रखें",
  "Add to compare": "तुलना में जोड़ें",
  "Brand": "ब्रांड",
  "Start_shopping": "शॉपिंग शुरू करें",
  "Select shipping method": "शिपिंग मेथड चुनें",
  "address CN": "चीन में पता, मौजूदा मुद्रा चीनी युआन होना चाहिए",
  "MyAccount_MyShippingDetails_State": "राज्य / प्रांत",
  "Page_not_found_message2": "वापस जाएं या पुनः प्रयास करें।",
  "Go_to_checkout": "चेकआउट पर जाएं",
  "See all results": "सभी परिणाम देखें",
  "search_results_inputnull": "आपने अभी तक कोई उत्पाद नहीं खोजा है।",
  "subscribeToNewsletterModalContent": "सदस्यता लेने के बाद, वीएसएफ से विशेष पेशकश और जानकारी आपको ईमेल द्वारा मिलेगी। हम कभी भी आपका ईमेल किसी तीसरे पक्ष को नहीं बेचते या वितरित करते हैं। हमारी {0} देखें।",
  "Download all": "सभी डाउनलोड करें",
  "Login_input_last": "अंतिम नाम",
  "Amount": "राशि",
  "ORDER_WAIT_PAYMENT": "भुगतान के लिए प्रतीक्षा कर रहा है",
  "Links": "लिंक",
  "article_category": "लेख श्रेणी",
  "wechat_code_login_message": "कृपया व्यवस्थापन्ने व्हाट्सऐप एक्सेस कमेरे द्वारे नोंदणी करावी",
  "wechat_code_login": "व्हाट्सऐप स्कैन लॉगिन",
  "Api_Update_success": "सफलतापूर्वक अपडेट किया गया है",
  "Please_Use_WeChat_login": "कृपया व्यवस्थापन्ने व्हाट्सऐप लॉगिन करा",
  "mobile_geshi_error": "कृपया वैध मोबाइल नंबर दर्ज करें",
  "Login_input_email_required": "ईमेल दर्ज करें",
  "article_null": "कोई लेख नहीं है",
  "Login_with_microsoft": "माइक्रोसॉफ्ट लॉगिन",
  "article_null_des": "आप अन्य श्रेणियों के लेख ब्राउज़ कर सकते हैं",
  "register_email": "ईमेल पंजीकरण",
  "Login_tab_email": "ईमेल लॉगिन",
  "code.time": "{time} सेकंड में पुनः प्रयास करें",
  "Login_with_wechat": "वीचैट लॉगिन",
  "cat_items_null_des": "आप अन्य श्रेणियों के उत्पाद ब्राउज़ कर सकते हैं",
  "Login_with_facebook": "फेसबुक लॉगिन",
  "Login_input_code": "कोड दर्ज करें",
  "Login_input_mobile_required": "मोबाइल नंबर दर्ज करें",
  "Login_input_mobile": "आपका मोबाइल नंबर",
  "cat_items_null": "इस श्रेणी में कोई उत्पाद नहीं है",
  "Login_with_twitter": "ट्विटर लॉगिन",
  "mobile_code": "कोड दर्ज करें",
  "register_mobile": "मोबाइल पंजीकरण",
  "Login_tab_mobile": "मोबाइल लॉगिन",
  "Login_with_google": "गूगल लॉगिन",
  "OrderSku": "माल की गुणवत्ता",
  "Order_logisticsNo": "लॉजिस्टिक्स संख्या",
  "order_shopping_firstname": "नाम",
  "Order_logisticsName": "लॉजिस्टिक्स कंपनी",
  "ItemPrice": "आइटम कीमत",
  "inPayOrderAll": "अधिकतम अपग्रेड",
  "payPrice": "भुगतान राशि",
  "shipping_add_success": "शिपिंग पता सफलतापूर्वक बनाया गया",
  "match_goods": "ट्रेंडिंग उत्पाद",
  "pay_code_refresh": "भुगतान कोड रीफ्रेश करें",
  "pay_code_shixiao": "भुगतान बारकोड अमान्य हो गया है",
  "concactus_title": "हमसे संपर्क करें",
  "Search_items": "खोज",
  "WebAutoLang": "आपके वर्तमान ब्राउज़र की अनुशंसित भाषा है: {lang}, क्या आप इस भाषा में स्विच करना चाहते हैं?",
  "Services_Name": "सेवा का नाम",
  "Services_Price": "सेवा का मूल्य",
  "SwichLang": "भाषा बदलें",
  "Services_Description": "सेवा का विवरण",
  "goodinfo_null": "कोई वस्तु नहीं",
  "goodinfo_null_des": "आप अन्य वर्ग के उत्पादों को ब्राउज़ कर सकते हैं",
  "notYetUseCode": "अभी तक उपयोग नहीं किया गया कोड",
  "guest_Login": "अतिथि लॉगिन",
  "billing_and_shipping": "बिलिंग और शिपिंग पता समान है",
  "select_coupon": "कूपन चुनें",
  "select_gift": "उपहार चुनें",
  "currentUseCode": "पहले से ही उपयोग किया गया कोड",
  "shipping_refresh": "सूची को रिफ्रेश करें",
  "Shipping_details": "पता प्राप्ति करना",
  "MyAccount_Newsletter": "सदस्यता",
  "MyAccount_Profile": "विवरण",
  "MyAccount_Wishlist": "इच्छा सूची",
  "See_all": "सभी",
  "MyAccount_History": "ऑर्डर रिकॉर्ड",
  "bind_microsoft": "बाइंड माइक्रोसॉफ्ट",
  "bind_twitter": "बाइंड ट्विटर",
  "bind_facebook": "बाइंड फेसबुक",
  "bind_wechat_code": "व्यवस्थित करें वेचैट कोड",
  "bind_wechat": "बाइंड वेचैट",
  "bind_google": "बाइंड गूगल",
  "Wishlist_Empty": "कोई इच्छा सूची नहीं",
  "discount_post_fee": "डाक अधिकतम छूट",
  "ORDER_PART_PAID": "कुछ हिस्सा भुगतान",
  "claimCouponeSuccess": "{name} कूपन सफलतापूर्वक दावा करें",
  "discount_kou": "{discount} कटौती",
  "claimCoupone": "लेना",
  "cartPreviewSafety_messageinfo": "आपके पते पर सुरक्षित और त्वरित वितरण",
  "Order_No": "आदेश संख्या",
  "cartPreviewSafety": "सुरक्षित वितरण",
  "Shipping": "शिपिंग",
  "MyAccount_MyShippingDetails_Street": "सड़क",
  "MyAccount_MyShippingDetails_HouseNumber": "घर का नंबर",
  "Shipping_title": "शिपिंग टाइटल",
  "Offline_payment": "ऑफ़लाइन भुगतान",
  "shopName": "शॉप नाम",
  "Social": "सामाजिक",
  "SERVICE": "सेवा",
  "onlineContact": "ऑनलाइन संपर्क",
  "confirm": "पुष्टि करें",
  "closeOrder": "आदेश रद्द करें",
  "closeOrderContext": "क्या आप वाकई ऑर्डर रद्द करना चाहते हैं?",
  "Message_Read": "पढ़ा हुआ",
  "close.order.success": "ऑर्डर सफलतापूर्वक रद्द हो गया है",
  "shippingAddress": "विस्तार से पता",
  "Message": "संदेश",
  "Message_Empty_Title": "आपका संदेश खाली है",
  "MyAccount_Message": "संदेश",
  "Message_Empty": "कोई संदेश नहीं है",
  "payment_order_note": "आदेश टिप्पणी",
  "go_to_see_prepid": "अवैतनिक आर्डर देखने के लिए यहाँ क्लिक करें",
  "operate": "कार्यवाही",
  "removeCartItemContext": "क्या आप {title} को हटाना चाहते हैं?",
  "shippingItemQty": "शिपिंग मात्रा",
  "removeCartItem": "आइटम हटाएं",
  "shippingInfo": "शिपिंग जानकारी",
  "Distributor_success": "वितरक के रूप में सफलतापूर्वक",
  "Distributor_apply": "वितरक बनने के लिए आवेदन करें",
  "Distributor_Details": "वितरक",
  "DistributorSataus": "स्थिति",
  "Distributor_Details_Empty": "कोई वितरक नहीं है",
  "distributor.status.4": "रद्द कर दिया गया है",
  "distributor.status.1": "अनुमोदित नहीं हुआ है",
  "Distributor_copy_url": "वितरण लिंक की प्रतिलिपि बनाएं",
  "Order_Time": "आदेश समय",
  "Order_User": "आदेश देने वाला व्यक्ति",
  "Distributor_copy_success": "सफलतापूर्वक प्रतिलिपि बनाएं",
  "distributor.status.3": "चुकाने के लिए रह गया है",
  "MyAccount_Distributor": "वितरक",
  "MyAccoubnt_Set_Distributor": "वितरक बनने के लिए आवेदन करें",
  "distributor.status.2": "चुकाया जाना है",
  "DistributorAmount": "कमीशन",
  "Distributor_shenheshibai": "वितरक समीक्षा विफल हुई",
  "Distributor_shenhezhong": "वितरक समीक्षा प्रक्रिया में है",
  "Distributor_Order_Empty": "वितरण आदेश अभी तक उपलब्ध नहीं हैं",
  "NE": "नाइजर",
  "DJ": "जिबूती",
  "KP": "उत्तर कोरिया",
  "US": "अमेरिका",
  "LC": "सेंट लुसिया",
  "NL": "नीदरलैंड",
  "CD": "कांगो- किंशासा",
  "IS": "आईसलैंड",
  "MA": "मोरक्को",
  "GH": "घाना",
  "KR": "दक्षिण कोरिया",
  "MK": "मैसेडोनिया",
  "HT": "हाइटी",
  "PF": "फ्रेंच पॉलिनेशिया",
  "GA": "गैबॉन",
  "TD": "चाड",
  "LB": "लेबनान",
  "CG": "कांगो - ब्राजाविले",
  "KG": "किर्गिजस्तान",
  "TA": "त्रिस्टान दा कुन्हा",
  "KW": "कुवैत",
  "TL": "पूर्व तिमोर",
  "IN": "भारत",
  "NO": "नॉर्वे",
  "NG": "नाइजीरिया",
  "AQ": "अंटार्कटिका",
  "LY": "लीबिया",
  "NI": "निकारागुआ",
  "TT": "त्रिनिदाद और टोबैगो",
  "HM": "हर्ड और मैकडोनाल्ड द्वीप समूह",
  "PY": "पारागुए",
  "BA": "बोस्निया और हर्ज़ेगोविना",
  "JP": "जापान",
  "MD": "मोल्डोवा",
  "MT": "माल्टा",
  "RE": "रियूनियन द्वीप",
  "UG": "युगांडा",
  "SB": "सोलोमन द्वीपसमूह",
  "SL": "सिएरा लियोन",
  "CV": "केप वर्दे",
  "SD": "सूडान",
  "FO": "फ़रो द्वीपसमूह",
  "ZA": "दक्षिण अफ्रीका",
  "TR": "तुर्की",
  "FK": "फ़ॉकलैंड द्वीपसमूह",
  "PA": "पनामा",
  "GF": "फ़्रांसीसी गुयाना",
  "TJ": "ताजिकिस्तान",
  "NC": "न्यू कैलेडोनिया",
  "PM": "सेंट पिएर और मिक्लॉन द्वीपसमूह",
  "NU": "न्यूए",
  "AO": "अंगोला",
  "VN": "वियतनाम",
  "GN": "गिनी",
  "MW": "मलावी",
  "BY": "बेलारूस",
  "IM": "आईल ऑफ मैन",
  "BI": "बुरुंडी",
  "BS": "बहामा",
  "CK": "कुक द्वीपसमूह",
  "MH": "मार्शल द्वीपसमूह",
  "CR": "कोस्टा रिका",
  "HK": "हाँग काँग",
  "AD": "अंडोरा",
  "BN": "ब्रुनेई",
  "SN": "सेनेगल",
  "AE": "संयुक्त अरब अमीरात",
  "GI": "जिब्राल्टर",
  "CA": "कनाडा",
  "AX": "ऑलैंड द्वीपसमूह",
  "UY": "उरुग्वे",
  "WF": "वालिस और फ़्यूचूना",
  "GM": "गांबिया",
  "SO": "सोमालिया",
  "RU": "रूस",
  "PL": "पोलैंड",
  "FM": "माइक्रोनेशिया",
  "ET": "इथियोपिया",
  "EE": "एस्टोनिया",
  "SK": "स्लोवाकिया",
  "AS": "अमेरिकी समोआ",
  "ZM": "जाम्बिया",
  "AL": "अल्बानिया",
  "AT": "ऑस्ट्रिया",
  "VA": "वेटिकन",
  "TW": "चीनी ताइवान",
  "BD": "बंगलादेश",
  "AR": "अर्जेंटिना",
  "EH": "पश्चिमी सहारा",
  "MO": "मकाऊ विशेष प्रशासनिक क्षेत्र चीन",
  "MV": "मालदीव",
  "GU": "गुआम",
  "AW": "अरूबा",
  "AI": "एंगुइला",
  "CL": "चिली",
  "IL": "इज़राइल",
  "GD": "ग्रेनेडा",
  "WS": "समोआ",
  "SE": "स्वीडन",
  "GP": "गुड़िया का हाथ में सुविधा",
  "YE": "यमन",
  "GT": "गोतेदाला",
  "BG": "बुल्गारिया",
  "SJ": "स्वालबार्ड और जान मायेन",
  "CO": "कोलम्बिया",
  "LS": "लेसोथो",
  "LV": "लात्विया",
  "UM": "अमेरिकी बाहरी द्वीप समूह",
  "MX": "मेक्सिको",
  "DO": "डोमिनिकन गणराज्य",
  "PE": "पेरू",
  "HN": "हॉण्डुरस",
  "TC": "टक्स और कैकोज़ द्वीप समूह",
  "VI": "वर्जिन द्वीप समूह, अमेरिका समूह",
  "FJ": "फ़िजी",
  "MP": "नॉर्थ मारियाना द्वीप समूह",
  "AC": "असेंशन आइलैंड",
  "NA": "नामीबिया",
  "SZ": "स्वाजीलैंड",
  "RW": "रवांडा",
  "BH": "बहरीन",
  "KN": "सेंट किट्स और नेविस",
  "TN": "ट्यूनीशिया",
  "AF": "अफ़गानिस्तान",
  "VG": "वर्जिन आईलैंड्स, ब्रिटिश",
  "KE": "केन्या",
  "PK": "पाकिस्तान",
  "GL": "ग्रीनलैंड",
  "SY": "सीरिया",
  "CU": "क्यूबा",
  "RS": "सर्बिया",
  "BF": "बुर्किना फासो",
  "BM": "बरमूडा",
  "BZ": "बेलिज",
  "SV": "अल साल्वाडोर",
  "CN": "चीन",
  "MF": "सेंट मार्टिन",
  "NF": "नॉरफ़ॉक",
  "MZ": "मोज़ाम्बिक",
  "LU": "लक्ज़मबर्ग",
  "TO": "टोंगा",
  "GR": "ग्रीस",
  "SI": "स्लोवेनिया",
  "PW": "पलाऊ द्वीपसमूह",
  "TZ": "तंजानिया",
  "IR": "ईरान",
  "GG": "गुर्ज़ि आईलैंड",
  "SM": "सैन् मारीनो",
  "TF": "फ़्रेंच दक्षिणी क्षेत्र",
  "PS": "फिलिस्तीन",
  "SC": "सेशेल्स",
  "BT": "भूटान",
  "JM": "जमाइका",
  "BR": "ब्राजील",
  "CH": "स्विट्ज़रलैंड",
  "SH": "सेंट हेलेना",
  "HU": "हंगरी",
  "TM": "तुर्कमेनिस्तान",
  "LT": "लिथुआनिया",
  "MC": "मोनाको",
  "LI": "लिकटेंस्टीन",
  "LR": "लाइबेरिया",
  "GE": "जॉर्जिया",
  "SA": "सऊदी अरब",
  "GB": "ब्रितानी राज्य",
  "VE": "वेनेजुएला",
  "MU": "मॉरिशस",
  "HR": "क्रोएशिया",
  "SR": "सुरिनाम",
  "CM": "कैमरून",
  "IQ": "इराक",
  "BO": "बोलीविया",
  "MN": "मंगोलिया",
  "DZ": "अल्जीरिया",
  "TK": "टोकलाउ",
  "MG": "मेडागास्कर",
  "YT": "मायोट्टे आइलैंड",
  "CC": "कोकोस द्वीप समूह",
  "LA": "लाओस",
  "PT": "पुर्तगाल",
  "QA": "कतर",
  "AN": "नीदरलैंड एंटिलीज आइलैंड्स",
  "PN": "पिटकेर्न",
  "ES": "स्पेन",
  "VC": "सेंट विन्सेंट एंड ग्रेनाडाइंस",
  "AU": "ऑस्ट्रेलिया",
  "CX": "क्रिसमस द्वीप",
  "KM": "कोमोरोस",
  "MR": "मॉरिटानिया",
  "FR": "फ़्रांस",
  "SG": "सिंगापुर",
  "BV": "बुवे आइलैंड",
  "PH": "फिलीपींस",
  "CY": "साइप्रस",
  "TV": "तुवालु",
  "CF": "केंद्रीय अफ्रीकी गणराज्य",
  "EC": "इक्वेडोर",
  "GW": "गिनी बिसाउ",
  "IE": "आयरलैंड",
  "LK": "श्रीलंका",
  "ER": "इरिट्रिया",
  "GQ": "इक्वेटोरियल गिनी",
  "NP": "नेपाल",
  "BE": "बेल्जियम",
  "GY": "गुयाना",
  "DK": "डेनमार्क",
  "MQ": "मार्टीनिक",
  "UZ": "उज्बेकिस्तान",
  "CI": "आईवरी कोस्ट",
  "ID": "इंडोनेशिया",
  "BJ": "बेनिन",
  "ST": "साओ टोमे और प्रिंसिपे",
  "KH": "कम्बोडिया",
  "KZ": "कजाखस्तान",
  "MS": "मॉन्टसेराट",
  "TH": "थाईलैंड",
  "FI": "फिनलैंड",
  "ML": "माली",
  "AM": "आर्मेनिया",
  "IT": "इटली",
  "NR": "नाउरू",
  "PG": "पापुआ न्यू गिनी",
  "ZW": "जिम्बाब्वे",
  "JO": "जॉर्डन",
  "OM": "ओमान",
  "ME": "मोंटेनेग्रो",
  "JE": "जर्सी",
  "NZ": "न्यूजीलैंड",
  "VU": "वानातू",
  "DE": "जर्मनी",
  "CZ": "चेक गणराज्य",
  "DM": "डोमिनिका",
  "KY": "कैमेन द्वीपसमूह",
  "BW": "बोत्सवाना",
  "RO": "रोमानिया",
  "PR": "पूर्तगाली भूमि में पैरा जाने वाले",
  "AZ": "अज़रबाइजान",
  "IO": "ब्रिटिश हिंद महासागरीय क्षेत्र",
  "UA": "यूक्रेन",
  "TG": "टोगो",
  "MY": "मलेशिया",
  "AG": "एंटीगुआ और बारबूडा",
  "EG": "मिस्र",
  "GS": "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीप समूह",
  "MM": "म्यांमार",
  "BB": "बारबाडोस द्वीप",
  "KI": "किरिबाती",
  "All_Country": "सभी",
  "post_state_country": "शिपिंग शुल्क: {country} {state} {postFee} ",
  "zhichiDeliveryCountry": "वितरण के लिए",
  "ShippingFee": "वितरण शुल्क",
  "reviewOutOf": "{rating} सितारे, कुल 5 सितारे",
  "product.pifa.label": "{startnum} - {endnum} आइटम खरीदें",
  "product.pifa.type.1": "डिस्काउंट",
  "Write_a_review": "एक समीक्षा लिखें",
  "BasedOnTotalReviews": "{total} समीक्षाओं पर आधारित",
  "product.wholesale": "होलसेल मूल्य",
  "reviewMostRecent": "नवीनतम समीक्षा",
  "product.pifa.type.2": "दर",
  "product.num.danwei": "एक",
  "good.shoppingDateLabel": "भेजने का समय",
  "good.shippingPeriod": "दिन में भेजा जाएगा",
  "emailError": "ईमेल प्रारूप गलत है",
  "addressNote": "टिप्पणी",
  "Concactus": "संपर्क",
  "addressMessage": "कृपया सुनिश्चित करें कि आपका पता सही और त्रुटिहीन है। चेकआउट के बाद हम पता बदलने में असमर्थ होंगे।",
  "showOrderSummary": "ऑर्डर सारांश",
  "payment_method": "भुगतान की विधि",
  "emailNotNullError": "ईमेल खाली नहीं हो सकता",
  "orderCreateLoading": "आदेश बनाने में ...",
  "emailNote": "संपर्क",
  "emailMessage": "कृपया सुनिश्चित करें कि आपका ईमेल पता सही और त्रुटिहीन है। हम आपको आदेश की पुष्टि करने वाला ईमेल भेजेंगे।",
  "payment_method_message": "सभी लेनदेन सुरक्षित और एन्क्रिप्टेड होते हैं।",
  "go_buy_goods": "खरीदारी जारी रखें",
  "tap_cancel_order": "आर्डर रद्द करने के लिए यहाँ टैप करें",
  "order_review": "ऑर्डर समीक्षा",
  "Add_new_address": "नया पता जोड़ें",
  "promo_code_type_3": "भर पेटी वाउचर",
  "IdCardNotNull": "कृपया वास्तविक नाम जानकारी भरें",
  "UploadVideo": "वीडियो अपलोड करें",
  "video": "वीडियो",
  "UploadImage": "छवि अपलोड करें",
  "uploadImageing": "अपलोड हो रहा है...",
  "BillingInfoNotNull": "बिलिंग जानकारी अपूर्ण है",
  "promo_code_type_2": "वाउचर मूल्यांकन",
  "UploadError": "अपलोड विफल हुआ",
  "promo_code_type_4": "शिपिंग चार्ज कम करने वाली वाउचर",
  "image": "छवि",
  "paymentMethodNotNull": "कृपया भुगतान का तरीका चुनें",
  "promo_code_type_1": "डिस्काउंट वाउचर",
  "shippingInfoNotNull": "शिपिंग जानकारी अपूर्ण है",
  "reviewDetail": "समीक्षा विवरण",
  "DeliveryCountry": "वितरण क्षेत्र",
  "prompt_error": "संकेत त्रुटि",
  "save_review_success": "समीक्षा सफलतापूर्वक सहेजी गई",
  "ORDER_COMPLETED": "पूर्ण किया गया",
  "crate_after_sales": "विक्रय के बाद सर्विस बनाएं",
  "Thank_You_Order": "आपके आदेश के लिए धन्यवाद!",
  "Thank_You_Order_sub": "आपका ऑर्डर जल्द ही प्रोसेस होगा, आपको ऑर्डर प्रोसेसिंग से संबंधित ईमेल मिलेगी।",
  "BootomCookieContext": "इस वेबसाइट का उपयोग कुकीज़ का सहारा लेने के लिए किया जाता है जो वेबसाइट को सामान्य रूप से चलाने में मदद करता है और हमें यह जानने में मदद करता है कि आप इससे कैसे इंटरैक्ट करते हैं। हम आपको बेहतर व्यक्तिगत उपयोगकर्ता अनुभव प्रदान करने के लिए इन कुकीज़ का उप",
  "order_reivice_message": "क्या आपने सामान प्राप्त कर लिया है?",
  "order_reivice_btn": "प्राप्ति की पुष्टि करें",
  "order_reivice_label": "ऑर्डर प्राप्ति",
  "order_reivice_success": "प्राप्ति सफलतापूर्वक की गई",
  "collpase_show": "अधिक देखें",
  "collpase_hide": "छिपना",
  "CouponCode": "कूपन कोड",
  "wechatPayScannerCode": "कृपया व्हाट्सएप स्कैनर कोड का उपयोग करके भुगतान करें",
  "processing": "बिक्री के बाद संसाधित हो रहा है",
  "finished": "बिक्री के बाद पूरा हो गया है",
  "login.showPrice": "लॉगिन करने के बाद कीमत देखें",
  "After_Sales_Unknown": "बिक्री के बाद की स्थिति अज्ञात है",
  "order_payment_list_null": "कोई_PENDING_भुगतान का आदेश नहीं है",
  "Cancel": "रद्द करें",
  "thankyou_concat": "यदि आपके पास कोई प्रश्न हैं, तो कृपया हमसे संपर्क करें"
}